<template>
  <v-btn
    depressed
    :color="color"
    link
    @click="navigateBack"
  >
    Wróć
    <span
      v-if="!enteredFromApp"
      class="ml-1"
    > do listy projektów</span>
  </v-btn>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'secondary',
    },
    prevRoute: {
      type: Object,
      required: true,
    },
    redirect: {
      type: String,
      default: 'projects-index',
    },
  },

  computed: {
    enteredFromApp() {
      return this.prevRoute?.name;
    },
  },

  methods: {
    navigateBack() {
      if (this.enteredFromApp) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: this.redirect });
      }
    },
  },
};
</script>
